import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ConfInicialesService } from './servicios/conf-iniciales.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  constructor(public route: Router, private confIniciales: ConfInicialesService) {
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        //console.log(event.urlAfterRedirects)
        if (event.urlAfterRedirects === '/login') {
          document.body.classList.add('no-scroll')
        } else {
          document.body.classList.remove('no-scroll');
        }
      })
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault();
      if (confIniciales.msgclosereload === true) {
        route.navigate(['login']);
        confIniciales.cerrarSesion2();
        const confirmationMessage = '\o/';
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    });
    window.addEventListener('popstate', (e) => {
      e.preventDefault();
      if (confIniciales.msgclosereload === true) {
        route.navigate(['login']);
        confIniciales.cerrarSesion2();
        const confirmationMessage = false;
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    });

  }


}
